import React, { useState } from 'react';
import {
  ClockIcon,
  TrashIcon,
  ContentWrapper,
  ModalSchedules,
  InteractiveButton,
  LabelPhoneMask
} from 'components';
import { DeleteContactService } from 'services';
import './phone-card.scss';
export function PhoneCard({ contact, id, update }) {

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const deleteContact = (idContact) => {
    DeleteContactService(idContact).then(() => {
      update();
    });
  }

  const toogleModal = (value) => {
    setModalIsOpen(value);
  }

  const openSchedules = () => {
    setModalIsOpen(true);
  }

  return (
    <div class="jumbotron">
      <LabelPhoneMask phone={contact}/>
      <hr class="my-2" />
      <ContentWrapper class={'d-flex justify-content-between main'}>
        <ContentWrapper>
          <InteractiveButton action={() => { }}>
            24h
          </InteractiveButton>
        </ContentWrapper>
        <ContentWrapper class={'d-flex'}>
          <ContentWrapper class={'d-flex justify-content-center edit'}>
            <InteractiveButton action={openSchedules}>
              <ClockIcon />
            Editar
          </InteractiveButton>
          </ContentWrapper>
          <ContentWrapper class={'d-flex justify-content-center'}>
            <InteractiveButton action={() => deleteContact(id)}>
              <TrashIcon />
              Excluir
            </InteractiveButton>
          </ContentWrapper>
        </ContentWrapper>
      </ContentWrapper>
      <ModalSchedules idContact={id} update={update} isOpen={modalIsOpen} toggleModal={toogleModal} close={toogleModal} />
    </div>
  );
}
